import { createStack } from '@famly/mf_layout_stack';
/**
 * Main content area for split modals. Use for primary forms, data displays, and core interactions.
 * Content scrolls when needed while maintaining footer position.
 *
 * @example
 * ```tsx
 * <SplitModalContentLeft>
 *   <Stack gap={3}>
 *     <TextField label="Name" />
 *     <TextField label="Email" />
 *     <Select label="Category" options={categories} />
 *   </Stack>
 * </SplitModalContentLeft>
 * ```
 */
export const SplitModalContentLeft = createStack({
    component: 'div',
    style: {
        gridArea: 'left',
    },
    padding: '24px',
    overflow: 'auto',
    minHeight: 0,
    flexDirection: 'column',
});
